<template>
  <v-card width="100%" class="modern-card" elevation="0">
    <apexchart width="100%" height="400px" type="line" :options="chartOptions" :series="chartSeries"></apexchart>
  </v-card>
</template>

<script>
export default {
  props: {
    title_header: {
      type: String,
      default: "Título del Gráfico",
    },
    data: {
      type: Object,
      default: () => ({
        label: [],
        series: [],
      }),
      required: true,
    },
    colors: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    chartSeries() {
      return [
        {
          name: "Valor",
          data: this.data.series,
        },
      ];
    },
    chartOptions() {
      return {
        chart: {
          height: 350,
          type: 'line',
          zoom: {
            enabled: true,
            type: 'x',
            autoScaleYaxis: true,
          },
          toolbar: {
            show: true,
            tools: {
              download: true,
              selection: true,
              zoom: true,
              zoomin: true,
              zoomout: true,
              pan: true,
              reset: true,
            },
          },
          animations: {
            enabled: true,
            easing: 'easeinout',
            speed: 800,
            animateGradually: {
              enabled: true,
              delay: 150
            },
            dynamicAnimation: {
              enabled: true,
              speed: 350
            }
          },
        },
        colors: ['#008FFB', '#00E396', '#FEB019', '#FF4560', '#775DD0'],
        title: {
          text: this.title_header,
          align: 'center',
          style: {
            fontSize: '22px',
            fontWeight: 'bold',
            fontFamily: 'Roboto, sans-serif',
            color: '#333',
          },
        },
        stroke: {
          curve: 'smooth',
          width: 3,
        },
        grid: {
          borderColor: '#e7e7e7',
          row: {
            colors: ['#f3f3f3', 'transparent'],
            opacity: 0.5
          },
        },
        markers: {
          size: 6,
          hover: {
            size: 8
          }
        },
        yaxis: {
          title: {
            text: 'Valor',
            style: {
              fontSize: '14px',
              fontWeight: 600,
              fontFamily: 'Roboto, sans-serif',
            }
          },
          labels: {
            formatter: function (value) {
              return value.toLocaleString('es-ES', { maximumFractionDigits: 2 });
            },
            style: {
              fontSize: '12px',
              fontFamily: 'Roboto, sans-serif',
            },
          },
        },
        xaxis: {
          categories: this.data.label,
          labels: {
            style: {
              fontSize: '12px',
              fontFamily: 'Roboto, sans-serif',
            },
          },
          title: {
            text: 'Categorías',
            style: {
              fontSize: '14px',
              fontWeight: 600,
              fontFamily: 'Roboto, sans-serif',
            }
          },
        },
        tooltip: {
          y: {
            formatter: function (value) {
              return value.toLocaleString('es-ES', { maximumFractionDigits: 2 });
            }
          }
        },
        legend: {
          show: true,
          position: 'top',
          horizontalAlign: 'right',
          floating: true,
          fontFamily: 'Roboto, sans-serif',
          fontSize: '14px',
        },
      };
    },
  },
  watch: {
    data: {
      handler: function (newValue) {
        this.$nextTick(() => {
          if (this.$refs.chart) {
            this.$refs.chart.updateOptions({
              xaxis: {
                categories: newValue.label,
              },
            });
            this.$refs.chart.updateSeries([{
              data: newValue.series
            }]);
          }
        });
      },
      deep: true,
      immediate: true
    },
    title_header: {
      handler: function (newValue) {
        this.$nextTick(() => {
          if (this.$refs.chart) {
            this.$refs.chart.updateOptions({
              title: {
                text: newValue,
              },
            });
          }
        });
      },
      immediate: true
    },
  },
};
</script>

<style scoped>
.modern-card {
  background-color: #FFFFFF !important;
  border-radius: 16px !important;
  border: 1px solid rgba(226, 232, 240, 0.8) !important;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05), 0 2px 4px -1px rgba(0, 0, 0, 0.03) !important;
  padding: 16px;
}

.v-card {
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
}

:deep(.apexcharts-legend-text) {
  font-family: 'Roboto', sans-serif !important;
}

:deep(.apexcharts-title-text) {
  font-family: 'Roboto', sans-serif !important;
}
</style>